// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IBodyRepairedQuarantine } from '~/utils/interface/quarantine';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IBodyRepairedQuarantine> => {
  return yup.object().shape({
    quarantineId: yup.string().optional(),
    repairedQuantity: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
  });
};

export const defaultValuesRepairedQuantity: IBodyRepairedQuarantine = {
  repairedQuantity: EMPTY_STRING,
};
